import * as actionTypes from "../actionTypes";

const initialValues = {
  resetCaptcha: 0,
  showCaptcha: false,
  loading: false,
  pwa_install: { mode: false, event: {} },
  Login_Recover_Page: 1,
  recoverLoginContact: "",
  officeAuth: null,
  currentOffice: null,
  authError: null,
  captchaCode: "",
  registerStageNumber: null,
  register_OTP: null,
  Register_Mobile_Email: "",
  register_initiated: false,
  traceCode: "",
  login_OTP: "",
  register_address: {
    address: "",
    district: "",
    city: "",
    province: "",
  },
  lat_lng: { lat: "", lng: "" },
};

export const loginReducer = (state = initialValues, action) => {
  let ret = "";
  switch (action.type) {
    case actionTypes.OFFICE_AUTH:
      ret = "officeAuth";
      break;

    case actionTypes.INVALID_AUTH:
      ret = "authError";
      break;
    case actionTypes.RECOVER_CODE:
      ret = "Login_Recover_Page";
      break;

    case actionTypes.CURRENT_OFFICE:
      ret = "currentOffice";
      break;

    case actionTypes.REGISTER_MOBILE_EMAIL:
      ret = "Register_Mobile_Email";
      break;

    case actionTypes.CAPTCHA:
      ret = "captchaCode";
      break;

    case actionTypes.PWA:
      ret = "pwa_install";
      break;

    case actionTypes.REGISTER_STAGE:
      ret = "registerStageNumber";
      break;

    case actionTypes.LOGIN_RECOVER_CONTACT:
      ret = "recoverLoginContact";
      break;

    case actionTypes.SHOW_CAPTCHA:
      ret = "showCaptcha";
      break;

    case actionTypes.REGISTER_OTP:
      ret = "register_OTP";
      break;

    case actionTypes.REGISTER_INITIATED:
      ret = "register_initiated";
      break;

    case actionTypes.REGISTER_ADDRESS:
      ret = "register_address";
      break;

    case actionTypes.LNG_LAT:
      ret = "lat_lng";
      break;

    case actionTypes.TRACE_CODE:
      ret = "traceCode";
      break;
    case actionTypes.LOGIN_OTP:
      ret = "login_OTP";
      break;
    case actionTypes.RESET_CAPTCHA:
      ret = "resetCaptcha";
      break;
    case actionTypes.LOADING:
      ret = "loading";
      break;

    default:
      return state;
  }
  return { ...state, [ret]: action.payload };
};
